export class OrderData {
  id: number;
  status: string;
  reference: string;

  project_order_id: number;

  clientId: number;
  clientName: string;

  constructor(init?: Partial<OrderData>) {
    Object.assign(this, init);
  }
}